import { alpha } from '@mui/material/styles';

import makeStyles from '@mui/styles/makeStyles';

const MWIDTH = 320;

export const Symbols = {
  icon: {
    width: 24,
    height: 24,
    fontSize: 24,
  },
};

export const useStyles = makeStyles((theme) => ({
  row: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    '& .inputEach': {
      marginLeft:theme.spacing(0.5),
      marginRight:theme.spacing(0.5),
    },
    '& .inputEach:first-child': {
      marginLeft: 0,
    },
    '& .inputEach:last-child': {
      marginRight: 0,
    },
  },
  centerColumn: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '1em',
  },
  formScrollContainer: {
    height: (p) => (p.showPosition ? 'calc(100% - 120px)' : p.useHeight ? '100%' : 'auto'),
    width: '100%',
    overflowX: 'hidden',
    overflowY: 'auto',
    boxSizing: 'border-box',
    padding: (p) => (p.showPosition ? `0 ${theme.spacing(2)}` : 'auto'),
  },
  formContainer: {
    maxWidth: MWIDTH * 2,
    position: 'relative',
    height: '100%',
    margin: 'auto',
    display: 'flex',
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
    },
  },
  formContainerNoMargin: {
    maxWidth: MWIDTH * 2,
    position: 'relative',
    height: '100%',
    display: 'flex',
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
    },
  },
  formContainerFullWidth: {
    maxWidth: 'none',
  },
  formWrap: {
    border: `1px solid ${theme.palette.action.disabled}`,
    padding: 6,
    borderRadius: 4,
    width: '100%',
    boxSizing: 'border-box',
  },
  formWrapHover: {
    border: `1px solid ${theme.palette.action.disabled}`,
    padding: 6,
    borderRadius: 4,
    width: '100%',
    boxSizing: 'border-box',

    '&:hover': {
      border: `1px solid ${theme.palette.action.disabled}`,
    },
  },
  realmsText: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    position: 'relative',
    top: -7,
    width: 'calc(100% - 30px)',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    color: theme.palette.text.primary,
  },
  canClick: {
    cursor: 'pointer',

    '&:hover': {
      border: `1px solid ${theme.palette.action.active}`,
    },
  },
  canClickDisabled: {
    cursor: 'default',
    border: 'none',
    pointerEvents: 'none',
  },
  appBar: {
    top: 'auto',
    bottom: 0,
    backgroundColor: (p) => (p.showPosition ? theme.palette.background.paper : 'transparent'),
    boxShadow: 'none',
  },
  formControl: {
    width: '100%',
  },
  formInputLabel: {
    backgroundColor: theme.palette.background.default,
    padding: '0 8px',
    marginTop: theme.spacing(-0.5),
    marginLeft: theme.spacing(2),
  },
  titleContainer: {
    maxWidth: MWIDTH,
    margin: `${theme.spacing(1)} 0`,
    alignSelf: 'flex-start',
  },
  title: {},
  titleRow: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    alignItems: 'center',
  },
  screenContainer: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    width: '100%',
    boxSizing: 'border-box',

    '& fieldset legend': {
      display: 'block',
    },

    '& .MuiToggleButtonGroup-root': {
      backgroundColor: 'transparent',
    },
  },
  colorSliderWrap: {
    padding: theme.spacing(2),
  },
  screenSubContainer: {
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',

    '& .MuiInputBase-root.Mui-disabled, .MuiInputLabel-formControl': {
      textFillColor: theme.palette.text.primary,
      color: theme.palette.text.primary,

      '& input, textarea, .MuiSelect-select': {
        textFillColor: theme.palette.text.primary,
        color: theme.palette.text.primary,
      },
    },
    '& .Mui-disabled.MuiInputBase-formControl .MuiSelect-icon': {
      display: 'none',
    },
    '& .Mui-disabled.MuiInput-underline:before': {
      border: `none !important`,
    },
    '& .inputEach': {
      alignItems: 'normal',
    },
  },
  screenSubContainerDialog: {
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',

    '& .MuiInput-formControl.Mui-disabled, .MuiInputLabel-formControl': {
      color: theme.palette.text.primary,
    },
    '& .Mui-disabled.MuiInputBase-formControl .MuiSelect-icon': {
      display: 'none',
    },
    '& .Mui-disabled.MuiInput-underline:before': {
      border: `none !important`,
    },
    '& .inputEach': {
      alignItems: 'normal',
    },
  },
  screenWrapper: {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    marginRight: theme.spacing(1),
    [theme.breakpoints.down('md')]: {
      width: '100%',
      marginRight: 0,
    },
  },
  collapsedScreen: {
    display: 'none',
  },
  collapseButton: {
    marginLeft: 10,
    '@media print': {
      display: 'none',
    },
  },
  inputEach: {
    paddingTop: theme.spacing(2),
    marginBottom: theme.spacing(1.5),
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    position: 'relative',

    '& .dropArea.ImageSelect': {
      position: 'absolute',
      top: 32,
      left: 14,
    },

    '& .MuiFormControl-root label': {
      color: theme.palette.text.secondary,
      textFillColor: theme.palette.text.secondary,
      // fontWeight: '500',
    },
  },
  inputDisabled: {
    borderBottom: `1px solid ${theme.palette.action.disabledBackground}`,
  },
  inputDisabledLast: {
    borderBottom: 'none',
  },
  itemRoot: {
    width: '100%',

    '& .RichText': {
      '& #mui-rte-container > div:nth-of-type(2)': {
        position: 'relative',
      },

      '& #mui-rte-editor': {
        position: 'relative',
      },
    },
  },
  dropZone: {
    padding: theme.spacing(1),
    // margin: theme.spacing(1),
    borderRadius: 10,
    width: '100%',

    '& .placeholderContent': {
      width: 215,
      height: 263,
      backgroundColor: theme.palette.action.disabled,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
  },
  dropZoneError: {
    borderColor: '#d32f2f !important',
  },
  imageWrap: {
    position: 'relative',
    margin: theme.spacing(1),
    width: 250,
    maxWidth: '100%',
  },
  comment: {
    width: '100%',
  },
  width100: {
    width: '100%',
  },
  multiSelectChipContainer: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    minHeight: 32,
  },
  multiSelectChipWrap: {
    margin: theme.spacing(0.5),
  },
  multiSelectChip: {
    marginRight: theme.spacing(0.5),
  },
  userSelectChip: {
    opacity: '1 !important',
    backgroundColor: theme.colors.transparent,
    fontSize: theme.typography.body1.fontSize,
    margin: `0px ${theme.spacing(0.5)} 0px 0px !important`,
    '& svg': {
      display: 'none',
    },
    '& .MuiChip-label': {
      padding: 0,
    },
  },
  toggleBtnRoot: {
    margin: `${theme.spacing(1)} 0`,
  },
  toggleListRoot: {
    marginLeft: theme.spacing(1),
  },
  topBottomSpacing: {
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
  },
  toggleFormControl: {
    paddingTop: 20,
    width: '100%',
  },
  richtextlabel: {
    transform: 'scale(1)',
    position: 'relative',
    left: '0px !important',
  },
  richtextlabeltop: {
    top: `-8px !important`,
  },
  richTextDisabled: {
    '& :first-child': {
      marginTop: theme.spacing(2.7),
    },
    '& :last-child': {
      marginBottom: theme.spacing(1),
    },
  },
  formControlCenter: {
    alignItems: 'center',
    justifyContent: 'center',
  },
  labelCenter: {
    left: 'auto',
  },
  ourLabel: {
    top: -21,
    left: -14,
    fontSize: 12,
    color: theme.palette.text.secondary,
    flexDirection: 'row',
    alignItems: 'center',
    display: 'flex',
    pointerEvents: 'auto',

    '& .MuiIcon-root': {
      color: theme.palette.text.secondary,
    },
  },
  infoIcon: {
    fontSize: 18,
    marginLeft: theme.spacing(1),
  },
  addBtn: {
    marginTop: 10,
    alignSelf: 'flex-start',
    marginRight: 10,
  },
  removeBtn: {
    backgroundColor: theme.palette.error.main,

    '&.MuiButton-contained:hover': {
      backgroundColor: alpha(theme.palette.error.main, 0.9),
    },
  },
  positionContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
  },
  positionWrap: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    width: 50,
  },
  posNumber: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: theme.palette.action.disabled,
    width: 36,
    height: 36,
    borderRadius: '50%',
    color: theme.colors.white,
    fontWeight: 'bold',
    marginBottom: 5,
    [theme.breakpoints.down('xl')]: {
      width: 30,
      height: 30,
    },
  },
  backgroundPrimary: {
    backgroundColor: theme.palette.primary.main,
  },
  posTitle: {
    color: theme.palette.action.disabled,
    fontSize: 12,
  },
  colorPrimary: {
    color: theme.palette.primary.main,
  },
  bar: {
    width: 50,
    height: 2,
    backgroundColor: theme.palette.action.disabled,
    margin: '0 5px 20px',
    [theme.breakpoints.down('xl')]: {
      width: 30,
    },
  },
  buttonsContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'space-between',
    justifyContent: 'center',
    margin: '15px 0',
  },
  button: {
    margin: '0 5px',
  },
  buttonFinish: {
    margin: '0 20px',
  },
  squareColor: {
    width: 48,
    height: 24,
  },
  chipAddChipContainer: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),

    '& .MuiChip-root': {
      marginBottom: theme.spacing(1),

      '& .MuiChip-label': {
        width: '100%',
      },
    },
  },
  colorPickerOverlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'transparent',
    zIndex: 999,
  },
  colorPicker: {
    position: 'absolute',
    top: 36,
    right: 0,
    zIndex: 1000,
  },
  initialFiles: {
    marginTop: theme.spacing(1.5),
    marginBottom: theme.spacing(1),

    '& .MuiChip-root': {
      marginBottom: theme.spacing(1),
      marginRight: theme.spacing(1),
    },
  },
}));
